import { FC } from 'react';
import cx from 'classnames/bind';
import { useMediaQuery } from 'react-responsive';

import { getTextPoint } from '@/utils/getTextPoint';

import styles from './Points.module.scss';

const cn = cx.bind(styles);

interface PointsProps {
  size?: 'large' | 'small';
  points: number;
  receivedPoints?: number;
  className?: string;
}

const Points: FC<PointsProps> = ({
  size = 'small',
  points,
  className,
  receivedPoints,
}) => {
  const isTablet = useMediaQuery({ query: '(min-width: 834px)' });

  return (
    <div className={className ? cn('points', className) : cn('points')}>
      {typeof receivedPoints === 'number' && (
        <span className={cn('receivedPoints')}>{receivedPoints}</span>
      )}
      <span>{points}</span>
      {isTablet && size === 'large' && (
        <span className={cn('points-text')}>
          &nbsp;{getTextPoint(20, ['балл', 'балла', 'баллов'])}
        </span>
      )}
    </div>
  );
};

export default Points;
